export const GET_CATEGORY_AVAILABLE_SORT_METHODS = /* GraphQL */ `
  query getCategoryAvailableSortMethods($categoryIdFilter: FilterEqualTypeInput!) {
    products(filter: { category_uid: $categoryIdFilter }) {
      sort_fields {
        options {
          label
          value
        }
      }
    }
  }
`;

export const GET_FILTER_INPUTS = /* GraphQL */ `
  query GetFilterInputsForModal {
    __type(name: "ProductAttributeFilterInput") {
      inputFields {
        name
        type {
          name
        }
      }
    }
  }
`;

export const GET_CATEGORY_FAQ = /* GraphQL */ `
  query getCategoryFaq($id: String!) {
    categories(filters: { category_uid: { eq: $id } }) {
      items {
        uid
        category_faq {
          question
          answer
        }
      }
    }
  }
`;

export const GET_CATEGORY_FILTER_DATA = /* GraphQL */ `
  query getCategoryFiltersData($filter: ProductAttributeFilterInput!) {
    products(filter: $filter) {
      aggregations {
        label
        count
        attribute_code
        options {
          label
          value
          alis_value
          parent_id
          url_key
          swatch_data {
            value
          }
          count
        }
        position
      }
    }
  }
`;

export const GET_SEARCH_PAGE_ALL_CATEGORY = /* GraphQL */ `
  query getSearchPageAllCategory {
    allCategories {
      items {
        id
        uid
        name
        url_key
        is_featured
      }
      aggregations {
        code
        option_id
        rewrite
      }
      sort_fields {
        default
        options {
          label
          value
        }
      }
    }
  }
`;

export const GET_CATEGORY_DETAIL = /* GraphQL */ `
  query GetCategoryDetail(
    $id: String!
    $pageSize: Int!
    $currentPage: Int!
    $filters: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput
    $filter_color: String
  ) {
    categories(filters: { category_uid: { in: [$id] } }) {
      items {
        uid
        url_key
        name
        short_description
        id
        description
        url_path
        meta_title
        meta_description
        meta_keywords
        category_image
        adv(currentPage: $currentPage) {
          id
          title
          img
          m_img
          link
          page
          position
          __typename
        }
      }
    }
    products(pageSize: $pageSize, currentPage: $currentPage, filter: $filters, sort: $sort) {
      items {
        id
        uid
        name
        product_mark
        prices {
          finalPrice {
            currency
            value
          }
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
        }
        presale_product {
          status
          label
          note
          shipping_to
          shipping_from
        }
        sku
        image {
          url
        }
        small_image {
          url
        }
        hover_image
        show_colors(width: 640, height: 640, category_uid: $id, filter_color: $filter_color) {
          items {
            label
            rgb
            image
            hover_image
            is_selected
          }
          total
        }
        stock_status
        rating_summary
        review_count
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            id: uid
            label
            values {
              label
              swatch_data {
                value
              }
              uid
            }
          }
        }
        __typename
        url_key
      }
      page_info {
        page_size
        current_page
        total_pages
      }
      total_count
    }
  }
`;

export const GET_PRODUCT_FILTER_OPTIONS_AND_SORT_FIELDS_BY_SEARCH = /* GraphQL */ `
  query getProductFiltersAndSortMethodsBySearch($search: String!, $filter: ProductAttributeFilterInput!) {
    products(search: $search, filter: $filter) {
      aggregations {
        label
        count
        attribute_code
        options {
          count
          label
          value
          parent_id
          url_key
          swatch_data {
            type
            value
          }
        }
        position
      }
      sort_fields {
        options {
          label
          value
        }
      }
    }
  }
`;

export const GET_ALL_CATEGORIES = /* GraphQL */ `
  query getAllCategories {
    allCategories {
      items {
        id
        uid
        name
        url_key
        is_featured
      }
      aggregations {
        code
        option_id
        rewrite
      }
      sort_fields {
        default
        options {
          label
          value
        }
      }
    }
  }
`;

export const GET_CATEGORY_SEO_INFO = /* GraphQL */ `
  query GetCategorySeo($id: String!) {
    categories(filters: { category_uid: { in: [$id] } }) {
      items {
        uid
        seo_rich_snippets
      }
    }
  }
`;

export const GET_PAGE_SIZE = /* GraphQL */ `
  query getPageSize {
    storeConfig {
      store_code
      grid_per_page
    }
  }
`;

export const GET_PRODUCT_SEO_INFO = /* GraphQL */ `
  query getProductSeoInfo($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        __typename
        id
        url_key
        seo_rich_snippets
        meta_title
        meta_keyword
        meta_description
      }
    }
  }
`;

export const GET_URL_RESOLVER = /* GraphQL */ `
  query getUrlResolver($url: String!) {
    urlResolver(url: $url) {
      id
      redirectCode
      relative_url
      type
    }
  }
`;

export const GET_CATEGORY_SEO_INFO_WITHOUT_RICH_SNIPPETS = /* GraphQL */ `
  query GetCategorySeo($id: String!, $layer_filter_items: [String]) {
    categories(filters: { category_uid: { eq: $id } }, layer_filter_items: $layer_filter_items) {
      items {
        id
        seo_rich_snippets
        uid
        name
        meta_title
        meta_keywords
        meta_description
      }
    }
  }
`;

export const GET_PRODUCT_SEO_INFO_WITHOUT_RICH_SNIPPETS = /* GraphQL */ `
  query getProductSeoInfo($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        __typename
        id
        meta_title
        meta_keyword
        meta_description
        url_key
      }
    }
  }
`;

const ProductDetailFragment = /* GraphQL */ `
  fragment ProductDetailFragment on ProductInterface {
    __typename
    best_value_mark
    categories {
      uid
      name
      breadcrumbs {
        category_uid
        category_name
      }
    }
    video_url
    description {
      html
    }
    short_description {
      html
    }
    presale_product {
      status
      label
      note
      shipping_to
      shipping_from
    }
    replacement_product {
      id
      uid
      name
      url_key
      rating_summary
      media_gallery {
        label
        url
      }
      price {
        regularPrice {
          amount {
            currency
            value
          }
        }
      }
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
      }
    }
    question_answer {
      name
      author
      email
      question
      answer
      date
    }
    id
    uid
    media_gallery_entries {
      uid
      label
      position
      disabled
      file
    }
    media_gallery_entries {
      uid
      disabled
      file
      label
      position
      url(type: "image", width: 700, height: 700)
    }
    name
    price {
      regularPrice {
        amount {
          currency
          value
        }
      }
    }
    price_range {
      maximum_price {
        final_price {
          currency
          value
        }
        discount {
          amount_off
        }
        regular_price {
          currency
          value
        }
      }
      minimum_price {
        final_price {
          currency
          value
        }
        regular_price {
          currency
          value
        }
        discount {
          amount_off
        }
      }
    }
    sku
    show_attribute {
      label
      code
      value
      __typename
    }
    small_image {
      url
    }
    stock_status
    url_key
    ... on ConfigurableProduct {
      configurable_options {
        attribute_code
        attribute_id
        uid
        label
        values {
          uid
          default_label
          label
          store_label
          use_default_value
          value_index
          swatch_data {
            ... on ImageSwatchData {
              thumbnail
            }
            value
          }
        }
      }
      variants {
        attributes {
          code
          value_index
        }
        product {
          best_value_mark
          swatch_image
          id
          uid
          presale_product {
            status
            label
            note
            shipping_to
            shipping_from
          }
          media_gallery_entries {
            uid
            disabled
            file
            label
            position
            url(type: "image", width: 700, height: 700)
          }
          hover_image(width: 120, height: 120)
          media_gallery {
            label
            url(type: "thumbnail", width: 120, height: 120)
            position
            disabled
          }
          sku
          stock_status
          price {
            regularPrice {
              amount {
                currency
                value
              }
            }
          }
          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              discount {
                amount_off
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_PAGE_DETAIL = /* GraphQL */ `
  query getProductPageDetail($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        uid
        rating_summary
        review_count
        recommend_summary {
          rating
          count
        }
        ratingStars {
          star
          count
        }
        seo_rich_snippets
        qty_bundle_rules {
          price
          qty
          type
        }
        ...ProductDetailFragment
      }
    }
  }
  ${ProductDetailFragment}
`;

export const GET_QUICK_VIEW_PRODUCT_DETAIL = /* GraphQL */ `
  query getQuickViewProductDetail($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        uid
        rating_summary
        review_count
        ...ProductDetailFragment
      }
    }
  }
  ${ProductDetailFragment}
`;

export const GET_PRODUCT_BREADCRUMBS = /* GraphQL */ `
  query getProductBreadcrumbs($category_uid: String!) {
    categories(filters: { category_uid: { eq: $category_uid } }) {
      items {
        breadcrumbs {
          category_uid
          category_level
          category_name
          category_url_path
          category_url_key
        }
        uid
        name
        url_path
        url_key
      }
    }
  }
`;

export const GET_PRODUCT_REVIEWS = /* GraphQL */ `
  query ProductReviews(
    $urlKey: String!
    $sort: ReviewsSortInput
    $review_current_page: Int!
    $pageSize: Int!
    $ip: String!
  ) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        __typename
        url_key
        rating_summary
        review_count
        recommend_summary {
          rating
          count
        }
        ratingStars {
          star
          count
        }

        easy_to_assemble_summary {
          rating
          count
        }
        value_for_money_summary {
          rating
          count
        }
        sturdiness_summary {
          rating
          count
        }
        easy_to_clean_summary {
          rating
          count
        }

        uid
        reviews(sort: $sort, currentPage: $review_current_page, pageSize: $pageSize) {
          items {
            id
            summary
            recommend
            reply
            reply_date
            text
            nickname
            created_at
            erp_review_id
            product_id
            review_image {
              id
              url
            }
            review_helpful(ip: $ip) {
              items {
                id
                is_help
                is_not_help
                is_owner
              }
              is_help_count
              is_not_help_count
            }
            average_rating
            ratings_breakdown {
              name
              value
            }
          }
          page_info {
            page_size
            current_page
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_PAGE_SEO_RELATED_PRODUCT = /* GraphQL */ `
  query getProductPageSeoRelatedProduct($urlKey: String!) {
    products(filter: { url_key: { eq: $urlKey } }) {
      items {
        id
        uid
        __typename
        id
        uid
        url_key
        related_products {
          id
          uid
          name
          url_key
          price_range {
            minimum_price {
              final_price {
                currency
                value
              }
            }
          }
          small_image {
            url
          }
        }
      }
    }
  }
`;

export const GET_ALL_TDK_TEMPLATE = /* GraphQL */ `
  query getAllTdkTemplate {
    allTDKTemplates {
      __typename
      category_ids
      meta_description
      meta_keywords
      meta_title
      type
    }
  }
`;

export const GET_BIRD_FEEDERS = /* GraphQL */ `
  query getBirdFeeders {
    TTBF001CP: products(filter: { sku: { eq: "TTBF001CP" } }) {
      items {
        id
        uid
        sku
        price_range {
          minimum_price {
            final_price {
              currency
              value
            }
          }
        }
      }
    }
    TTBF002CP: products(filter: { sku: { eq: "TTBF002CP" } }) {
      items {
        id
        uid
        sku
        price_range {
          minimum_price {
            final_price {
              currency
              value
            }
          }
        }
      }
    }
    TTBF003CP: products(filter: { sku: { eq: "TTBF003CP" } }) {
      items {
        id
        uid
        sku
        price_range {
          minimum_price {
            final_price {
              currency
              value
            }
          }
        }
      }
    }
  }
`;
